import React, { useMemo } from 'react';
import TableBody from '@mui/material/TableBody'
import { TableRowStyled, TableCellStyled } from "../styling/tableStyles";

export default function TableSortBody(props) {
  const { tabledata, cheads, order, orderBy } = props;
 
  function descendingComparator(a, b, orderBy, order) {
    const sortOrder = order === "asc" ? 1 : -1;
    // move missing values (M) and empty cells to end of sort
    const missing = order === "asc" ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER;
    const asort = ["M", ""].includes(a[orderBy]) ? missing : a[orderBy];
    const bsort = ["M", ""].includes(b[orderBy]) ? missing : b[orderBy];
    //return a[orderBy].toString().localeCompare(b[orderBy].toString(), "en", {numeric: true}) * sortOrder;
    return (asort - bsort) * sortOrder;
  }
  
  function getComparator(order, orderBy) {
    return (a, b) => descendingComparator(a, b, orderBy, order)
  }
  
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  
  const visibleRows = useMemo(() =>
    stableSort(tabledata, getComparator(order, orderBy)),
    [order, orderBy, tabledata],
  );
  
  return (
  	<>
      <TableBody>
        {visibleRows.map((trow, r) => {
          return (
            <TableRowStyled key={"r"+r} sx={trow.sx}>
              {cheads.map((hc) => {
                if (!hc.invisible && hc.id !== null) {
                  const sx = hc.component === "th" ? {fontWeight:500+"!important"} : {}
                  return (
                    <TableCellStyled sx={sx} key={hc.id} >
                      {trow[hc.id].toLocaleString("en")}
                    </TableCellStyled>
                  )
                }
              })}
            </TableRowStyled>
          )
        })}
      </TableBody>
  	</>
  )
}